module.exports = __webpack_public_path__ + "img/case3.af6f6124.jpg";